import combineReducers from 'react-combine-reducers';
import { authReducer, initialAuthState } from './auth-reducer';
import { initialWebsiteSwitchState, websiteSwitchReducer } from './website-switch-reducer';
import { initialWebsiteAnalyticsState, websiteAnalyticsReducer } from './website-analytics-reducer';
import { initialLeadsState, leadsReducer } from './leads-reducer';
import { contentReducer, initialContentState } from './content-reducer';
import { ppcReducer, initialPpcState } from './ppc-reducer';
import { campaignUpdatesReducer, initialCampaignUpdatesState } from './campaign-updates-reducer';
import { digitalPRReducer, initialDigitalPRState } from './digital-pr-reducer';
import { premiumBacklinkReducer, initialPremiumBacklinkState } from './premium-backlink-reducer';
import { yextReducer, initialYextState } from './yext-reducer';
import { geoVisibilityReducer, initialGeoVisibilityState } from './geo-visibility-reducer';

const [reducer, store] = combineReducers({
  // combining reducers and initialStates here to make global store
  auth: [authReducer, initialAuthState],
  websiteSwitch: [websiteSwitchReducer, initialWebsiteSwitchState],
  websiteAnalytics: [websiteAnalyticsReducer, initialWebsiteAnalyticsState],
  leads: [leadsReducer, initialLeadsState],
  ppc: [ppcReducer, initialPpcState],
  content: [contentReducer, initialContentState],
  campaignUpdates: [campaignUpdatesReducer, initialCampaignUpdatesState],
  digitalPR: [digitalPRReducer, initialDigitalPRState],
  premiumBacklinks: [premiumBacklinkReducer, initialPremiumBacklinkState],
  yext: [yextReducer, initialYextState],
  geoVisibility: [geoVisibilityReducer, initialGeoVisibilityState],
});

export { store, reducer };
